var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.6646C13.748 17.6646 17.6577 13.7549 17.6577 9.00684C17.6577 4.26709 13.7397 0.349121 8.9917 0.349121C4.25195 0.349121 0.342285 4.26709 0.342285 9.00684C0.342285 13.7549 4.25195 17.6646 9 17.6646ZM8.07861 13.1323C7.73828 13.1323 7.47266 12.9829 7.22363 12.6758L5.22314 10.2686C5.05713 10.061 4.98242 9.86182 4.98242 9.6377C4.98242 9.17285 5.34766 8.79932 5.8125 8.79932C6.08643 8.79932 6.30225 8.90723 6.51807 9.17285L8.05371 11.0986L11.3989 5.75293C11.5981 5.4458 11.8472 5.27979 12.1377 5.27979C12.5859 5.27979 13.001 5.60352 13.001 6.06836C13.001 6.26758 12.9014 6.4917 12.7769 6.68262L8.90039 12.6675C8.70117 12.9663 8.41064 13.1323 8.07861 13.1323Z",
    fill: "#34C759"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoingIcon);
export default __webpack_public_path__ + "static/media/goingIcon.ef0fadd31b8aa420edbe28e247102307.svg";
export { ForwardRef as ReactComponent };